module.exports = __webpack_public_path__ + "img/preview-overview.56bbb25c.png";